module.exports = require("what-the-diff");